import { rootApi } from "../../../services/rootApi";

export interface ITOUUrlRequest {
    email: string
}
export interface IUMSUrlRequest {
    username: string
}

export interface IURlResult {
    url: string,
}

const jguApi = rootApi.injectEndpoints({
    overrideExisting: false,

    endpoints: (builder) => ({
        touUrl: builder.query<IURlResult, ITOUUrlRequest>({
            query: (request) => ({
                url: `/JGU/TOU-Url`,
                method: "POST",
                body: request,
            }),
        }),

        umsUrl: builder.query<IURlResult, IUMSUrlRequest>({
            query: (request) => ({
                url: `/JGU/UMS-Url`,
                method: "POST",
                body: request,
            }),
        }),
    }),
})

export const {
    useTouUrlQuery,
    useUmsUrlQuery,
} = jguApi;